module.exports = __webpack_public_path__ + "img/amtl-elastical-films.d99bb847.png";